import { Game } from './Game.js';
import * as Audio from './Audio.js';

const game = new Game();

// Unlock Web Audio on first user interaction
document.addEventListener('click', () => Audio.unlock(), { once: true });

const menuScreen = document.getElementById('menu-screen');
const onlineLobby = document.getElementById('online-lobby');

// ── Online battle ───────────────────────────────
document.getElementById('btn-online').addEventListener('click', () => {
  menuScreen.classList.add('hidden');
  onlineLobby.classList.add('active');
});

document.getElementById('btn-connect').addEventListener('click', async () => {
  const serverUrl = document.getElementById('server-url').value.trim();
  const roomCode = document.getElementById('room-code').value.trim();
  if (!serverUrl) {
    document.getElementById('lobby-status').textContent = 'Please enter a server URL';
    return;
  }
  await game.startOnlineGame(serverUrl, roomCode);
});

document.getElementById('btn-back-lobby').addEventListener('click', () => {
  onlineLobby.classList.remove('active');
  menuScreen.classList.remove('hidden');
});

// ── Controls info ───────────────────────────────
document.getElementById('btn-controls').addEventListener('click', () => {
  const isMob = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
  if (isMob) {
    alert(`
╔═══════════════════════════════════════╗
║        RPS ARENA — CONTROLS           ║
╠═══════════════════════════════════════╣
║                                       ║
║  TOUCH CONTROLS                       ║
║  ──────────────                       ║
║  Left Joystick = Move                 ║
║  🪨 Button     = Throw Rock           ║
║  📄 Button     = Paper Block (hold)   ║
║  ✂️ Button     = Scissors Slash       ║
║  💨 Button     = Dash                 ║
║  ✕  Button     = Back to Menu         ║
║                                       ║
╠═══════════════════════════════════════╣
║  COMBAT RULES                         ║
║  ────────────                         ║
║  🪨 Rock     → Ranged  (25 dmg)      ║
║  📄 Paper    → Block rocks            ║
║  ✂️ Scissors → Melee   (18 dmg)      ║
║            → 2× vs Paper!            ║
║                                       ║
║  ⚠️ Zone closes — stay inside!        ║
║  Win 2 rounds to win.                 ║
╚═══════════════════════════════════════╝
  `.trim());
  } else {
    alert(`
╔════════════════════════════════════════════════════╗
║               RPS ARENA — CONTROLS                ║
╠════════════════════════════════════════════════════╣
║                                                    ║
║  MOVEMENT                                          ║
║  ────────                                          ║
║  Z Q S D  = Move                                   ║
║  Space    = Dash                                   ║
║                                                    ║
║  WEAPONS                                           ║
║  ───────                                           ║
║  X        = Throw Rock                             ║
║  C (hold) = Paper Block                            ║
║  V        = Scissors Slash                         ║
║                                                    ║
║  CAMERA                                            ║
║  ──────                                            ║
║  Mouse     = Look around (click to lock)           ║
║  F         = First-Person view (FPS)               ║
║  G         = Third-Person view (TPS)               ║
║                                                    ║
╠════════════════════════════════════════════════════╣
║  COMBAT RULES                                      ║
║  ────────────                                      ║
║  🪨 Rock     → Long-range projectile  (25 dmg)     ║
║  📄 Paper    → Block (absorbs rocks)               ║
║  ✂️ Scissors → Melee slash  (18 dmg)                ║
║              → 2× damage if enemy uses Paper!      ║
║                                                    ║
║  ⚠️ Zone closes after 15s — stay inside!            ║
║  Win 2 rounds to win the match.                    ║
║  ESC = Return to menu                              ║
╚════════════════════════════════════════════════════╝
  `.trim());
  }
});

// ── ESC to quit ─────────────────────────────────
window.addEventListener('keydown', (e) => {
  if (e.code === 'Escape' && game.running) game.returnToMenu();
});

// ── Mobile: back-to-menu button ─────────────────
const isMobileDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
if (isMobileDevice) {
  const menuBtn = document.createElement('button');
  menuBtn.id = 'mobile-back-btn';
  menuBtn.textContent = '✕';
  menuBtn.style.cssText = `
    position: fixed; top: 10px; right: 10px; z-index: 70;
    width: 36px; height: 36px; border-radius: 50%;
    background: rgba(0,0,0,0.5); border: 1px solid rgba(255,255,255,0.2);
    color: #fff; font-size: 18px; cursor: pointer;
    display: none; align-items: center; justify-content: center;
    -webkit-tap-highlight-color: transparent; touch-action: manipulation;
    pointer-events: auto;
  `;
  document.body.appendChild(menuBtn);
  menuBtn.addEventListener('touchstart', (e) => {
    e.preventDefault();
    if (game.running) game.returnToMenu();
  }, { passive: false });

  // Show/hide based on game state
  const origOnline = game.startOnlineGame.bind(game);
  game.startOnlineGame = async function(...args) {
    const result = await origOnline(...args);
    if (result) menuBtn.style.display = 'flex';
    return result;
  };
  const origReturn = game.returnToMenu.bind(game);
  game.returnToMenu = function() {
    origReturn();
    menuBtn.style.display = 'none';
  };
}

console.log('⚔️ RPS Arena loaded.');
